import { render, staticRenderFns } from "./JiaotongTongdaFenxiDatail.vue?vue&type=template&id=b9fa3782&scoped=true&"
import script from "./JiaotongTongdaFenxiDatail.vue?vue&type=script&lang=js&"
export * from "./JiaotongTongdaFenxiDatail.vue?vue&type=script&lang=js&"
import style0 from "./JiaotongTongdaFenxiDatail.vue?vue&type=style&index=0&id=b9fa3782&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fa3782",
  null
  
)

export default component.exports